import { Box, Flex, Image, Text } from "@chakra-ui/react";
import AlertTriangleIcon from "assets/img/profile/alert-triangle.svg";

interface DashboardErrorBannerProps {
  message: string;
}

export const DashboardErrorBanner: React.FC<DashboardErrorBannerProps> = ({ message }) => {
  return (
    <Box
      bg="#FEF2F2"
      borderRadius="8px"
      px={{ base: "16px", md: "24px" }}
      py={{ base: "10px", md: "12px" }}
    >
      <Flex alignItems="center" columnGap="8px">
        <Image src={AlertTriangleIcon} alt="" w="18px" h="18px" />
        <Text fontSize="14px" color="#991B1B">
          {message}
        </Text>
      </Flex>
    </Box>
  );
};

export default DashboardErrorBanner;
